import { createMuiTheme, Theme } from '@material-ui/core/styles';
import { colors } from '~web/view/theme/colors';
import { dimensions } from '~web/view/theme/dimensions';
import { fontSizes, lineHeights, space } from '~web/view/theme/scales';
import { transitions } from '~web/view/theme/transitions';
import { typography } from '~web/view/theme/typography';
import { zIndex } from '~web/view/theme/z-index';

export const theme = {
  colors,
  dimensions,
  fontSizes,
  lineHeights,
  space,
  transitions,
  typography,
  zIndex,
};

/**
 * Converts our custom theme object to a valid Material UI theme
 * object (`muiTheme`).
 */
const themeToMuiTheme = (ownTheme: ThemeInterface): Theme =>
  createMuiTheme({
    typography: ownTheme.typography,
    palette: {
      type: 'dark',
      primary: {
        main: ownTheme.colors.white,
      },
      secondary: {
        main: ownTheme.colors.purple.primary,
      },
      error: {
        main: ownTheme.colors.error,
      },
      background: {
        default: ownTheme.colors.background,
      },
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiCheckbox: {
        disableRipple: true,
      },
    },
    overrides: {
      MuiMenu: {
        paper: {
          borderRadius: '16px',
          background: ownTheme.colors.gray.v6,
          border: `2px solid ${ownTheme.colors.gray.v3}`,
          scrollbarColor: 'rgba(255, 255, 255, 0.1) rgba(0, 0, 0, 0)',
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            width: '8px',
            background: 'rgba(0, 0, 0, 0)',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '4px',
            '-webkit-border-radius': '4px',
          },
        },
      },
      MuiMenuItem: {
        root: {
          '&$selected, &:hover, &$selected&:hover': {
            backgroundColor: `${ownTheme.colors.withAlpha(ownTheme.colors.white)(0.08)}`,
          },
        },
      },
      MuiIconButton: {
        root: {
          '&$colorSecondary, &:hover, &$colorSecondary&:hover': {
            background: 'none',
          },
        },
      },
      MuiFormLabel: {
        root: {
          color: ownTheme.colors.gray.v1,
        },
      },
    },
  });

export const muiTheme: Theme = themeToMuiTheme(theme);

export type ThemeInterface = typeof theme;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/theme/index.ts